import { seoFragment, sustainabilityBlockFragment } from './fragments.gql'

export default `query SustainabilityPage {
  sustainabilityPage {
    title
    intro
    ${seoFragment}
    rows {
      id
      columns {
        ${sustainabilityBlockFragment}
      }
    }
    quote
    quoteAttribution
    sectionTitle
    sectionText
  }
}`
